module.exports = __webpack_public_path__ + "static/media/pic2.8d109c83.jpg";